/** Ünvan seçenekleri — sistem yetkisi (Admin/Lawyer) değildir. */
export const USER_TITLES = [
  { value: 'Avukat', label: 'Avukat' },
  { value: 'Stajyer', label: 'Stajyer' },
  { value: 'Katip', label: 'Katip' },
  { value: 'Asistan', label: 'Asistan' },
  { value: 'CocukIsci', label: 'Çocuk İşçi' }
];

/** @deprecated USER_TITLES kullanın */
export const USER_ROLES = USER_TITLES;

export const getTitleLabel = (title) => {
  if (!title) return '-';
  if (title === 'Lawyer' || title === 'lawyer') return 'Avukat';
  const found = USER_TITLES.find((t) => t.value === title);
  return found ? found.label : title;
};

export const getRoleLabel = (role) => {
  if (!role) return '-';
  if (role === 'Admin' || role === 'admin') return 'Admin';
  if (role === 'Lawyer' || role === 'lawyer') return 'Kullanıcı';
  // Eski veri: Role'a yazılmış ünvan
  return getTitleLabel(role);
};

export const normalizeTitleForSelect = (title, role) => {
  const t = title || role;
  if (!t) return 'Avukat';
  if (t === 'Lawyer' || t === 'lawyer' || t === 'Admin' || t === 'admin' || t === 'Staff') return 'Avukat';
  if (USER_TITLES.some((x) => x.value === t)) return t;
  return 'Avukat';
};

/** @deprecated normalizeTitleForSelect kullanın */
export const normalizeRoleForSelect = normalizeTitleForSelect;
